<template>
  <div>
    <el-row>
      <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4'>
        <phd-registry-menu>
        </phd-registry-menu>
      </el-col>
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16'>
        <phd-registration v-show="phdRegistrationVisible"></phd-registration>
        <application-search v-show="searchVisible"></application-search>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PhdRegistryMenu from './roleSpecific/PhdRegistryMenu'
import PhdRegistration from './common/PhdRegistration.vue'
import ApplicationSearch from '@/components/common/ApplicationSearch'

export default {
  name: 'PhdRegistry',
  components: {
    PhdRegistryMenu,
    PhdRegistration,
    ApplicationSearch
  },
  computed: {
    ...mapState([
      'phdRegistrationVisible',
      'searchVisible'
    ])
  }
}
</script>

<style lang="scss">
.list-group {
  min-height: 20px;
}

.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PhdRegistry.vue